import React from 'react';
import { formatListValue } from '@/shared/components/FormattedListValue';
import { useIntl } from 'react-intl';
import RenderProperty from './RenderProperty';
import messages from './FieldMessages';

const EnumChange = props => {
  const intl = useIntl();
  const { log } = props;

  const property = RenderProperty({ intl, log });

  if (!log.oldValue) {
    return (
      <span>
        {intl.formatMessage(messages.SetEnum, {
          property,
          value: formatListValue({ id: log.newValue.Value, list: log.newValue.Name, intl }),
          b: value => <b>{value}</b>,
          i: value => <i>{value}</i>,
        })}
      </span>
    );
  }

  if (!log.newValue) {
    return (
      <span>
        {intl.formatMessage(messages.ClearEnum, {
          property,
          value: formatListValue({ id: log.oldValue.Value, list: log.oldValue.Name, intl }),
          b: value => <b>{value}</b>,
          i: value => <i>{value}</i>,
        })}
      </span>
    );
  }

  return (
    <span>
      {intl.formatMessage(messages.ChangedField, {
        property,
        originalValue: formatListValue({ id: log.oldValue.Value, list: log.oldValue.Name, intl }),
        currentValue: formatListValue({ id: log.newValue.Value, list: log.newValue.Name, intl }),
        b: value => <b>{value}</b>,
        i: value => <i>{value}</i>,
      })}
    </span>
  );
};

export default EnumChange;
